export function formatNumber(number,decimals) {
  
  if (number === undefined) return number;
  if (number === null) return undefined;
  let formatted;
  let deci =  decimals !== undefined ? decimals : '' ;
  
  number = number.toFixed(deci);
  number = number.replace(/[$.]/g,',');
  number = number.toString();

  formatted = number.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  
  //formatted = number.replace(/(\d)(\d{3})($|,|\.)/g, '$1.$2$3');
  // for (;;) {
  //   formatted = number.replace(/(\d)(\d{3})($|,|\.)/g, '$1.$2$3');    
  //   if (formatted === number) break;
  //   number = formatted;
  // }
  return formatted;
}


export  function unitizeNumber(num, digits, unit='num-short') {
    let noUnit = unit === false;
    unit = unit === false ? 'num-short': unit;
    const units = {
        'num-short':['UNIT_THOUSAND_SHORT', 'UNIT_MILLION_SHORT', 'UNIT_BILLION_SHORT', 'UNIT_TRILLION_SHORT'],
        'num':['UNIT_THOUSAND', 'UNIT_MILLION', 'UNIT_BILLION', 'UNIT_TRILLION']        
      };

    let shorten = {'num':num,'unit':''};
    let decimal;
    
    for(let i = units[unit].length - 1; i>=0; i--) {
        decimal = Math.pow(1e3, i+1);
        if(num <= -decimal || num >= decimal) {          
          if(noUnit) return +(num / decimal).toFixed(digits);
          shorten.num = +(num / decimal).toFixed(digits);
          shorten.unit = units[unit][i];          
         return shorten;
        }
    }   
    return noUnit ? num : shorten;
}
